const valueOf = (row, camelCase, pascalCase) => row?.[camelCase] ?? row?.[pascalCase] ?? "";

const normalized = (value) => String(value || "").trim().toLocaleUpperCase();

export const courierGroupKey = (row = {}) => {
    const blNo = normalized(valueOf(row, "blNo", "BLNo"));
    if (blNo) return `bl:${blNo}`;

    return `vessel:${normalized(valueOf(row, "vesselName", "VesselName")) || "UNASSIGNED"}`;
};

// A BL is the most precise courier grouping. Until a BL is entered, containers
// on the same vessel share one courier row.
export const buildCourierGroups = (shipments = [], savedDetails = [], legacyCourier = {}) => {
    const groups = [];
    const byKey = new Map();

    shipments.forEach((shipment) => {
        const key = courierGroupKey(shipment);
        let group = byKey.get(key);
        if (!group) {
            group = {
                key,
                vesselName: String(valueOf(shipment, "vesselName", "VesselName") || "").trim(),
                blNo: String(valueOf(shipment, "blNo", "BLNo") || "").trim(),
                containerCount: 0,
                courierDate: "",
                refNo: "",
                docReceiveDate: ""
            };
            byKey.set(key, group);
            groups.push(group);
        }
        group.containerCount += 1;
    });

    const savedByKey = new Map(savedDetails.map((detail) => [courierGroupKey(detail), detail]));
    return groups.map((group, index) => {
        const saved = savedByKey.get(group.key);
        const fallback = !saved && index === 0 ? legacyCourier : {};
        const source = saved || fallback || {};
        return {
            ...group,
            courierDetailId: source.CourierDetailID ?? source.courierDetailId ?? null,
            courierDate: valueOf(source, "courierDate", "CourierDate") || "",
            refNo: valueOf(source, "refNo", "RefNo") || "",
            docReceiveDate: valueOf(source, "docReceiveDate", "DocRecDate") || ""
        };
    });
};

